import { createSelector } from 'reselect';

import { FORM_KEYS } from '../form-designer/constants/form-manager.constants';
import {
  getComponentProps,
  getTranslations,
  getUserRights,
  getUserRoles,
} from '../form-designer/selectors/common.selectors';
import { isNilOrEmpty } from '../utils/ramdaUtils';

export const getAppOptions = (state) => state.appOptions;

export const getAppOptionByKey = (key) =>
  createSelector(getAppOptions, (appOptions) => appOptions[key]);

export const getAppSettings = (state) => state.appSettings;

export const getAppSettingsByKey = (key) =>
  createSelector(getAppSettings, (appSettings) => appSettings[key]);

export const getOrgHierarchy = (state) => state.orgHierarchy;

export const getIsConfigMissed = createSelector(
  [getAppOptions, getAppSettings, getUserRights, getUserRoles, getOrgHierarchy, getTranslations],
  (appOptions, appSettings, userRights, userRoles, orgHierarchy, translations) => {
    return [
      appOptions,
      appSettings,
      userRights,
      userRoles,
      orgHierarchy,
      translations.languages,
    ].some((config) => isNilOrEmpty(config));
  }
);

export const getAppConfig = (state) => state.appConfig;

export const getPreventFormMounting = createSelector(
  [getAppConfig, getComponentProps],
  (appConfig) => {
    return !!(
      appConfig.failedEndpointsList[FORM_KEYS.STEP] ||
      appConfig.failedEndpointsList[FORM_KEYS.DETAIL]
    );
  }
);
